export const EXTRA_BOTTOM_ROWS = 3;
